import { render, staticRenderFns } from "./ListTabMain.vue?vue&type=template&id=52d0a682&"
import script from "./ListTabMain.vue?vue&type=script&lang=js&"
export * from "./ListTabMain.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports